(function() {
    'use strict';

    var addBasketHtml = 'Add <span class="hidden-sm">to basket</span>',
        addedBasketText = 'Added',
        addBasketIcon = 'btn-icon-add',
        upsellsAddedClass = 'upsells-added';
    var urlParams = new URLSearchParams(window.location.search);
    var basketDealLineId = urlParams.get('basketDealLineId');
    var baseErrorMessage = "We're sorry, we couldn't add or remove this accessory. ";

    var setAddedAccessoryToBasketHtml = function (data) {
        return '<p data-deal-id-addition="'+ data.dealId + '">' +
            '<button onclick="ga(\'send\', \'event\', \'Bespoke Pages\', \'Extras\', \'Remove\');" ' +
            'data-remove-additional-item="' + data.dealId + '" ' +
            'data-basket-deal-line-id="' + data.basketDealLineId + '" ' +
            'data-deal-id="' + data.dealLine + '" ' +
            'class="btn-link btn-remove-accessory">' +
            '<i aria-hidden="true"></i>' +
            '</button>' +
            '<span class="accessory-name">+ ' + data.productUrl + '</span>' +
            '<span class="price">' + data.productPrice + '</span>' +
            '</p>';
    }

    var sendRequest =  function (action, data, successCallback, errorCallBack){
        var url = action ==='add_render' ? '/ajax/render_related_product.json'
            : action === 'add' ? '/ajax/add-to-basket' : '/ajax/remove-deal-from-basket';

        $.ajax({
            dataType: 'json',
            url: url,
            method: 'POST',
            data: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest',
            },
            success: function(data) {
                successCallback(data);
            },
            error: function() {
                errorCallBack();
            }
        })
    }

    $('[data-addition-to-basket]').on('click', function(event) {
        var self = $(this);
        var dataSend;

        if (self.attr('disabled') === 'disabled') {
            return false;
        }

        self.text('Adding...');
        self.attr('disabled', 'disabled');
        event.preventDefault();
        event.stopPropagation();

        if (basketDealLineId) {
            dataSend = {
                'dealId': self.data('deal-id'),
                'giftCode': self.data('gift-code'),
                'itemType': 'deal',
                'parentId': basketDealLineId ? 'deal-' + basketDealLineId : null
            };
        } else {
            dataSend = {
                'related-product-id': self.data('deal-id')
            };
        }

        var successCallback = function (data) {
            if (data.success) {
                var renderHtml;
                if (basketDealLineId) {
                    renderHtml = setAddedAccessoryToBasketHtml({
                        'dealId': data.basketDealLineId.replace('deal-', ''),
                        'basketDealLineId': data.basketDealLineId,
                        'dealLine': self.data('deal-id'),
                        'giftCode': self.data('gift-code') || 'NA',
                        'productUrl': self.data('product-url'),
                        'productPrice': self.data('product-price'),
                    })
                } else {
                    renderHtml = data.html
                }

                $('[data-accessories]').addClass(upsellsAddedClass);
                $('[data-chosen-items]').append(renderHtml);
                self.find('i.' + addBasketIcon).remove();
                self.closest('.tile-accessory').addClass('selected-accessory');
                self.text(addedBasketText);
                self.append('<i class="accessory-added" aria-hidden="true"></i>');
                basketCounter.init();
                $('html, body').animate({
                    scrollTop: $('[data-main-deal-container]').offset().top - 100
                }, 1000);
            } else {
                removeItem(self.data('deal-id'));
                showErrorModal(baseErrorMessage + data.html);
            }
        };

        var errorCallback = function () {
            removeItem(self.data('deal-id'));
            showErrorModal(baseErrorMessage + "Try refreshing the page and try again. If that doesn't work please contact us and let us know.");
        };

        sendRequest(basketDealLineId ? 'add' : 'add_render', dataSend, successCallback, errorCallback);
    });

    $('body').on('click', '[data-remove-additional-item]', function() {
        var self = $(this)
        if (basketDealLineId) {
            var errorCallback = function () {
                showErrorModal(baseErrorMessage + "Try refreshing the page and try again. If that doesn't work please contact us and let us know.");
            };

            var successRemoveCallback = function (data) {
                if (data.success) {
                    removeItem(self.data('remove-additional-item'), self.data('deal-id'));
                    basketCounter.init();
                } else {
                    errorCallback();
                }
            };

            var data = {
                basketDealLineId:  self.data('basket-deal-line-id')
            };

            sendRequest('remove', data, successRemoveCallback, errorCallback);
        } else {
            removeItem(self.data('remove-additional-item'));
        }
    });

    function removeItem(dealId, dealItemId) {
        var dealButtonId = dealItemId ? dealItemId : dealId;
        var additionButton = $('[data-addition-to-basket="' + dealButtonId + '"]');
        additionButton.removeAttr('disabled');
        additionButton.find('i').remove();
        additionButton.closest('.tile-accessory').removeClass('selected-accessory');
        additionButton.html(addBasketHtml);
        additionButton.append('<i class="' + addBasketIcon + '"></i>');

        if ($('[data-deal-id-addition="' + dealId + '"]').length) {
            $('[data-deal-id-addition="' + dealId + '"]').remove();
        }

        if (!$('[data-deal-id-addition]').length) {
            $('[data-accessories]').removeClass(upsellsAddedClass);
        }
    }

    function showErrorModal(message) {
        $('.error-popup').find('[data-error-advice]').html(message);
        $('.error-popup').modal();
    }

    $('[data-toggle-accessories-popup]').on('click', function(event) {
        var t = $(this),
            cachedModalHtml = t.data('cached-modal-html'),
            target = $('.accessories-popup'),
            accessoriesHref = '/ajax/accessories.json';
        event.preventDefault();
        event.stopPropagation();
        var options = {
            'deal-id': t.data('deal-id')
        };
        if (!cachedModalHtml) {
            $.ajax({
                dataType: 'json',
                url: accessoriesHref,
                data: options,
                success: function(data) {
                    if (data.success) {
                        cachedModalHtml = data.html;
                        t.data('cached-modal-html', cachedModalHtml);
                        target.html(cachedModalHtml);
                        $(target).modal();
                    }
                }
            });
        } else {
            target.html(cachedModalHtml);
            $(target).modal();
        }
    });
})($);
